export const INTERNAL_PATH = 'lootboy:/';
export const LOOTBOY_COM_URL_BASE = 'https://www.lootboy.com';
export const LOOTBOY_DE_URL_BASE = 'https://www.lootboy.de';
